import { Icon, IFormRender, Label } from '@busybusy/webapp-react-ui';
import { ArrowDownIcon } from 'assets/icons';
import FeatureTimeFormField from 'components/domain/time/FeatureTimeFormField/FeatureTimeFormField';
import BasicPickerFormField from 'components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField';
import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { DateTime } from 'luxon';
import ClockAction from 'types/enum/ClockAction';
import { t } from 'utils/localize';
import { ClockInRestrictionType } from '__generated__/graphql';
import './ClockInRestrictionFormFields.scss';

export interface IClockInRestrictionFormFieldsProps<T extends IClockInRestrictionFieldsData> {
  form: IFormRender<T>;
}

export interface IClockInRestrictionFieldsData {
  clockInRestriction: ClockInRestrictionType;
  clockInRestrictionStartTime: DateTime | null;
}

const basicPickerOptions: Array<IBasicPickerValue<ClockInRestrictionType>> = [
  { id: ClockInRestrictionType.Off, name: t('Off') },
  { id: ClockInRestrictionType.Time, name: t('Start Time') },
  { id: ClockInRestrictionType.Schedule, name: t('Schedule Only') },
];

function ClockInRestrictionFormFields<T extends IClockInRestrictionFieldsData>({
  form,
}: IClockInRestrictionFormFieldsProps<T>) {
  const clockInRestrictionHasTime = form.state.data.clockInRestriction === 'time';

  return (
    <>
      <BasicPickerFormField
        name="clockInRestriction"
        data={basicPickerOptions}
        form={form}
        closeButtonRender={() => (
          <span className="drop-icon">
            <Icon svg={ArrowDownIcon} />
          </span>
        )}
      />
      {clockInRestrictionHasTime && (
        <>
          <Label>{t('Start Time')}</Label>
          <FeatureTimeFormField form={form} name="clockInRestrictionStartTime" clockAction={ClockAction.CLOCK_IN} />
        </>
      )}
    </>
  );
}

export default ClockInRestrictionFormFields;
